import React, { ReactElement, useState } from 'react';
import Picker from './Picker';
import Wheels from './Wheel';

import './index.less';

interface Props {
  title: string;
  show: boolean;
  date: any;
  selectedIndexs: [0];
  onCancel: () => void;
  onSure: (value: any) => void;
}

// @ts-ignore
export default function DatePicker(props: Props): ReactElement {
  const [selectedIndex, setSelectedIndexs] = useState([]);
  const onChange = (value, index, selectedIndexs) => {
    const values = selectedIndexs;
    setSelectedIndexs(values);
  };
  const onSure = () => {
    props.onSure(selectedIndex);
  };
  return (
    <Picker
      title="选择时间"
      show={props.show}
      onCancel={props.onCancel}
      onSure={onSure}
      render={() => (
        <Wheels
          pickerDate={props.date}
          show={props.show}
          selectedIndexs={props.selectedIndexs}
          onChange={onChange}
          onSure={onSure}
        />
      )}
    />
  );
}
